module.exports = __webpack_public_path__ + "static/media/moderator-new-question.f365c293.gif";